import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

const storageKeys = [StorageKeys.Keys.LICENSEAPIKEY, StorageKeys.Keys.DEVICEREGDATA];

export const isLoggedInDevice = () => {
  const res = storageKeys.filter((key) => Storages.MainStorage.getItem(key)).length>0;
  return res
};
